<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="upload-load-spinner"></fab-loading-spinner>
<div class="file-container">
  <input type="file" class="no-display-file-input"
         (change)="onFileSelected($event)"
         (click)="$event.target.value=null"
         accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
         #fileUpload />
  {{fileName || "No file uploaded yet."}}
  <button mat-raised-button color="primary" id="upload-button" (click)="fileUpload.click()">Upload</button>
</div>

<div class="progress progress-bar-custom">
  <mat-progress-bar id="progress-bar"
                    class="progress-bar"
                    mode="determinate"
                    [value]="uploadProgress"
                    [hidden]="uploadProgress === 0"
                    *ngIf="uploadProgress">
  </mat-progress-bar>

  <mat-icon (click)="cancelUpload()" *ngIf="uploadProgress">cancel</mat-icon>
</div>
